import { RetirementPage } from "@/features/retirement/pages/Retirement";

const Retirement = () => {
  return <RetirementPage />;
};

export default Retirement;
